"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSaveReferrer = exports.useScrollToHashId = exports.redirectToDomain = exports.useQParams = exports.useQParam = exports.useSearch = exports.setQParam = exports.useFieldValue = exports.usePrevious = exports.usePageViews = exports.useTrackedState = exports.useRecommendationSubmitter = exports.useBatchSubmitter = exports.useVariableIdSubmitter = exports.useSubmitter = void 0;
var end2end_1 = require("@hudled/end2end");
var debounce_1 = __importDefault(require("lodash/debounce"));
var mapKeys_1 = __importDefault(require("lodash/mapKeys"));
var mapValues_1 = __importDefault(require("lodash/mapValues"));
var pick_1 = __importDefault(require("lodash/pick"));
var react_1 = require("react");
var react_final_form_1 = require("react-final-form");
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var react_router_1 = require("react-router");
var analytics_1 = require("../analytics");
var fieldProcessors_1 = require("../fieldProcessors");
var firestore_1 = require("../firebase/firestore");
var logging_1 = require("../logging");
var single_1 = require("../selectors/single");
/**
 * Uses setMerge
 * */
var useSubmitter = function (col, existingDocumentId, fixedValues, delayMs) {
    var _a = __read((0, exports.useVariableIdSubmitter)(col, fixedValues, delayMs), 2), submit = _a[0], isSubmitting = _a[1];
    return [function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return submit.apply(void 0, __spreadArray([existingDocumentId], __read(args), false));
        }, isSubmitting];
};
exports.useSubmitter = useSubmitter;
/**
 * Uses setMerge
 * */
var useVariableIdSubmitter = function (col, fixedValues, delayMs) {
    var auth = (0, react_redux_1.useSelector)(single_1.selectAuth);
    var firestore = (0, react_redux_firebase_1.useFirestore)();
    var _a = __read((0, react_1.useState)(false), 2), isSubmitting = _a[0], setIsSubmitting = _a[1];
    var identifyOnSubmit = (0, analytics_1.useIdentifyOnSubmit)(col);
    var isUnmounted = (0, react_1.useRef)(false);
    var track = (0, analytics_1.useOldTracker)();
    (0, react_1.useEffect)(function () { return function () { isUnmounted.current = true; }; }, []);
    return [
        function (existingDocumentId, submittedValues, eventIdentifier) { return __awaiter(void 0, void 0, void 0, function () {
            var docRef, valuesToSave, valuesWithUserData, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        docRef = (0, firestore_1.makeDocRef)(col, existingDocumentId || undefined);
                        if (!(submittedValues === 'DELETE')) return [3 /*break*/, 3];
                        if (!existingDocumentId) return [3 /*break*/, 2];
                        return [4 /*yield*/, firestore.collection(col).doc(existingDocumentId).delete()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        setIsSubmitting(false);
                        return [2 /*return*/, docRef];
                    case 3:
                        if (isSubmitting)
                            return [2 /*return*/, docRef];
                        if (!isUnmounted.current)
                            setIsSubmitting(true);
                        valuesToSave = __assign(__assign({}, fixedValues), submittedValues);
                        _a.label = 4;
                    case 4:
                        _a.trys.push([4, 9, , 10]);
                        valuesWithUserData = __assign(__assign({}, valuesToSave), { lastChangeUid: auth.uid, creatorUid: existingDocumentId ? undefined : auth.uid });
                        if (!existingDocumentId) return [3 /*break*/, 6];
                        return [4 /*yield*/, firestore.collection(col).doc(existingDocumentId).set(valuesWithUserData, { merge: true })];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 6: return [4 /*yield*/, firestore.collection(col).add(valuesWithUserData)];
                    case 7:
                        _a.sent();
                        _a.label = 8;
                    case 8: return [3 /*break*/, 10];
                    case 9:
                        e_1 = _a.sent();
                        setIsSubmitting(false);
                        (0, logging_1.logError)('Submission failed for:', col, existingDocumentId, e_1);
                        throw e_1;
                    case 10:
                        track(eventIdentifier || "".concat(existingDocumentId ? 'updating' : 'creating', "-").concat(col), __assign(__assign(__assign({ path: window.location.pathname }, (0, end2end_1.cleanFbData)((0, mapKeys_1.default)(submittedValues, function (v, k) { return "submittedValues.".concat(k); }))), (0, end2end_1.cleanFbData)((0, mapKeys_1.default)(fixedValues, function (v, k) { return "fixedValues.".concat(k); }))), { collection: col, docId: existingDocumentId }));
                        if (!delayMs) return [3 /*break*/, 12];
                        return [4 /*yield*/, (0, end2end_1.delay)(delayMs)];
                    case 11:
                        _a.sent();
                        _a.label = 12;
                    case 12:
                        if (!isUnmounted.current)
                            setIsSubmitting(false);
                        identifyOnSubmit(docRef);
                        return [2 /*return*/, docRef];
                }
            });
        }); },
        isSubmitting,
    ];
};
exports.useVariableIdSubmitter = useVariableIdSubmitter;
var useBatchSubmitter = function (col, existingDocumentsIds, fixedValues) {
    var firebase = (0, react_redux_firebase_1.useFirebase)();
    var auth = (0, react_redux_1.useSelector)(single_1.selectAuth);
    var _a = __read((0, react_1.useState)(false), 2), isSubmitting = _a[0], setIsSubmitting = _a[1];
    var _b = __read((0, react_1.useState)(0), 2), submittedCnt = _b[0], setSubmittedCnt = _b[1];
    var isUnmounted = (0, react_1.useRef)(false);
    var track = (0, analytics_1.useOldTracker)();
    (0, react_1.useEffect)(function () { return function () { isUnmounted.current = true; }; }, []);
    return [
        function (submittedValues, eventIdentifier) { return __awaiter(void 0, void 0, void 0, function () {
            var valuesToSave, collectionRef, chunkSize, _loop_1, i;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (isSubmitting)
                            return [2 /*return*/];
                        if (!isUnmounted.current)
                            setIsSubmitting(true);
                        valuesToSave = __assign(__assign(__assign({}, fixedValues), submittedValues), { lastChangeUid: auth.uid });
                        collectionRef = firebase.firestore().collection(col);
                        chunkSize = 40;
                        _loop_1 = function (i) {
                            var batch;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        setSubmittedCnt(i);
                                        batch = firebase.firestore().batch();
                                        existingDocumentsIds.slice(i, i + chunkSize).forEach(function (docId) { return batch.update(collectionRef.doc(docId), valuesToSave); });
                                        // eslint-disable-next-line no-await-in-loop
                                        return [4 /*yield*/, batch.commit()];
                                    case 1:
                                        // eslint-disable-next-line no-await-in-loop
                                        _b.sent();
                                        if (!(i + chunkSize < existingDocumentsIds.length)) return [3 /*break*/, 3];
                                        // eslint-disable-next-line no-await-in-loop
                                        return [4 /*yield*/, (0, end2end_1.delay)(300)];
                                    case 2:
                                        // eslint-disable-next-line no-await-in-loop
                                        _b.sent();
                                        _b.label = 3;
                                    case 3: return [2 /*return*/];
                                }
                            });
                        };
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < existingDocumentsIds.length)) return [3 /*break*/, 4];
                        return [5 /*yield**/, _loop_1(i)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        i += chunkSize;
                        return [3 /*break*/, 1];
                    case 4:
                        track(eventIdentifier || "".concat(existingDocumentsIds ? 'updating' : 'creating', "-").concat(col), {
                            path: window.location.pathname,
                            /* eslint-disable no-underscore-dangle,@typescript-eslint/ban-ts-comment */
                            // @ts-ignore
                            submittedValues: (0, mapValues_1.default)(submittedValues, function (val) { return typeof val !== 'string' && val && 'i_' in val ? val.i_ : val; }),
                            /* eslint-enable no-underscore-dangle,@typescript-eslint/ban-ts-comment */
                            fixedValues: fixedValues,
                            collection: col,
                            docIds: existingDocumentsIds,
                        });
                        if (!isUnmounted.current)
                            setIsSubmitting(false);
                        return [2 /*return*/];
                }
            });
        }); },
        isSubmitting,
        submittedCnt,
    ];
};
exports.useBatchSubmitter = useBatchSubmitter;
var useRecommendationSubmitter = function (recommendation) {
    var _a = __read((0, exports.useSubmitter)('recommendations', recommendation.id, (0, pick_1.default)(recommendation, ['serviceStatId', 'type', 'companyId'])), 2), updateRecommendationBase = _a[0], isSending = _a[1];
    var updateRecommendation = function (values, originalDataKey, eventIdentifier) { return __awaiter(void 0, void 0, void 0, function () {
        var valuesToSave;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    valuesToSave = __assign({}, values);
                    if (originalDataKey && !recommendation[originalDataKey]) {
                        valuesToSave[originalDataKey] = (0, fieldProcessors_1.pickRecommendationOriginalData)(recommendation);
                    }
                    return [4 /*yield*/, updateRecommendationBase(valuesToSave, eventIdentifier)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return [updateRecommendation, isSending];
};
exports.useRecommendationSubmitter = useRecommendationSubmitter;
var useTrackedState = function (eventName, defaultValue) {
    var _a = __read((0, react_1.useState)(defaultValue), 2), state = _a[0], setState = _a[1];
    var track = (0, analytics_1.useOldTracker)();
    return [
        state,
        function (newState) {
            track(eventName, { oldState: state, newState: newState, defaultValue: defaultValue });
            setState(newState);
        },
    ];
};
exports.useTrackedState = useTrackedState;
var usePageViews = function () {
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    var location = (0, react_router_1.useLocation)();
    (0, react_1.useEffect)(function () {
        window.analytics.page(location.pathname, {}, { context: { groupId: "company-".concat(profile.companyId) } });
    }, [location.pathname]);
};
exports.usePageViews = usePageViews;
var usePrevious = function (val) {
    var ref = (0, react_1.useRef)(val);
    (0, react_1.useEffect)(function () { ref.current = val; }, [val]);
    return ref.current;
};
exports.usePrevious = usePrevious;
var useFieldValue = function (name) {
    var value = (0, react_final_form_1.useField)(name, { subscription: { value: true } }).input.value;
    var prevValue = (0, exports.usePrevious)(value);
    return [value, prevValue];
};
exports.useFieldValue = useFieldValue;
var setQParam = function (qParam, history) { return (0, debounce_1.default)(function (searchText) {
    var newQueryParams = new URLSearchParams(window.location.search);
    if (searchText) {
        newQueryParams.set(qParam, searchText);
    }
    else {
        newQueryParams.delete(qParam);
    }
    var newSearchString = "".concat(newQueryParams);
    var newLocation = "".concat(window.location.pathname).concat(newSearchString ? "?".concat(newSearchString) : '');
    if (history) {
        history.push(newLocation);
        return;
    }
    window.history.pushState({}, '', newLocation);
}, 300); };
exports.setQParam = setQParam;
var useSearch = function (qParam) {
    if (qParam === void 0) { qParam = 'search'; }
    var queryParams = new URLSearchParams(window.location.search);
    var searchQueryParameter = queryParams.get(qParam);
    var _a = __read((0, react_1.useState)(searchQueryParameter !== null && searchQueryParameter !== void 0 ? searchQueryParameter : ''), 2), searchText = _a[0], setSearchText = _a[1];
    var debouncedSetSearchQParam = (0, react_1.useMemo)(function () { return (0, exports.setQParam)(qParam); }, [qParam]);
    (0, react_1.useEffect)(function () {
        // Handling when user in my-stack switches from a service to another without closing
        setTimeout(function () {
            var _a;
            var newQParams = new URLSearchParams(window.location.search);
            var newValue = (_a = newQParams.get(qParam)) !== null && _a !== void 0 ? _a : '';
            if (searchText !== newValue) {
                setSearchText(newValue);
            }
        }, 500);
        // Empty parameter on unmount
        return function () { return (0, exports.setQParam)(qParam)(''); };
    }, []);
    return [
        searchText,
        function (s) {
            setSearchText(s);
            debouncedSetSearchQParam(s);
        },
    ];
};
exports.useSearch = useSearch;
var getQParams = function (location) { return Object.fromEntries(new URLSearchParams(location.search).entries()); };
var useQParam = function (qParam) { return new URLSearchParams((0, react_router_1.useLocation)().search).get(qParam); };
exports.useQParam = useQParam;
var useQParams = function () { return getQParams((0, react_router_1.useLocation)()); };
exports.useQParams = useQParams;
var redirectToDomain = function (app, location) {
    var qParams = getQParams(location);
    var state = (0, end2end_1.parseStateString)(qParams.state);
    var domain = state.domainCode && end2end_1.DOMAIN_MAP[state.domainCode];
    if (domain) {
        var redirectUrl = window.location.origin + window.location.pathname;
        window.location.href = "https://".concat(domain, "/oauth/").concat(app).concat(location.search, "&redirectUrl=").concat(encodeURIComponent(redirectUrl));
    }
};
exports.redirectToDomain = redirectToDomain;
var useScrollToHashId = function (shouldScroll) {
    var location = (0, react_router_1.useLocation)();
    (0, react_1.useEffect)(function () {
        var hash = location.hash;
        if (shouldScroll) {
            setTimeout(function () {
                var el = hash && document.getElementById(hash.substr(1));
                if (el)
                    el.scrollIntoView({ behavior: 'smooth' });
            }, 50);
        }
    }, [location.hash, shouldScroll]); // Fires every time hash changes
};
exports.useScrollToHashId = useScrollToHashId;
var useSaveReferrer = function () {
    var location = (0, react_router_1.useLocation)();
    var urlSearchParams = new URLSearchParams(location.search);
    (0, react_1.useEffect)(function () {
        var referredBy = urlSearchParams.get('ref') || urlSearchParams.get('ref_id');
        if (referredBy) {
            localStorage.referredBy = referredBy;
            localStorage.lastReferredAt = Date.now();
        }
    }, []);
};
exports.useSaveReferrer = useSaveReferrer;
